import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Blokery reklam (Brave/uBlock/EasyList) blokują KAŻDE żądanie ze ścieżką
// zawierającą „/ads/". API kampanii mieszka pod /api/ads/, więc user z blokerem
// dostawał puste listy (np. „Brak kampanii"). Przepisujemy ścieżkę na neutralny
// alias /panel/ - backend serwuje go równolegle do /api/ads/.
function dodgeAdblock(path) {
  if (typeof path === 'string' && path.startsWith('/ads/')) {
    return '/panel/' + path.slice('/ads/'.length);
  }
  return path;
}

// Pełny URL dla bezpośrednich fetch() (eksporty/pobrania) z tym samym omijaniem blokera.
export function apiUrl(path) {
  const base = process.env.REACT_APP_API_URL || '/api';
  return base + dodgeAdblock(path);
}

api.interceptors.request.use((config) => {
  config.url = dodgeAdblock(config.url);
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isAuthEndpoint = url.includes('/login') || url.includes('/register') || url.includes('/google/login');
      if (!isAuthEndpoint) {
        localStorage.removeItem('token');
        window.location.href = '/logowanie';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
